export default {
  // Tooltip y mensajes específicos
  editRequirementsTooltip: 'Editar requisitos de horas y créditos',
  viewRequirementsTooltip: 'Ver requisitos de horas y créditos',
  editRequirementsModalTitle: 'EDITAR REQUISITOS DE HORAS Y CRÉDITOS',
  viewRequirementsModalTitle: 'VER REQUISITOS DE HORAS Y CRÉDITOS',

  // LimitStudyPlan
  total: 'TOTAL',
  maximumSuggestedIn: 'Máximo sugerido en {entity}',
  hours: 'Horas',
  credits: 'Créditos',
  level: 'NIVEL',
  levelName: '{level} NIVEL',
  maximumSuggestedCredits: 'Máximo sugerido de Créditos',
}
